module.exports = __webpack_public_path__ + "img/bg_pressalit.72387e19.png";